{
  "title": "Skogeieropplysninger",
  "description": "Legg til eller endre opplysninger rundt valgt skogeier",
  "changeForestOwnerType": {
    "organizationTitle": "Endre skogeiertype til organisasjon"
  },
  "changeOrganizationNumber": {
    "title": "Endring av organisasjonsnummer kan påvirke leverandørtilknytninger",
    "description": "Når du endrer organisasjonsnummer, kan leverandørnumre tilknyttet eiendommer trenge oppfølging eller oppdatering for å sikre at koblingene forblir korrekte.",
    "changeOrganizationNumber": "Endre organisasjonsnummer",
    "notInRegistrar": "Sameie er ikke registrert i brønnøysundregisteret",
    "nameOfPartnership": "Navn på sameie",
    "nameOfPartnershipExample": "Eksempel: Trevirke Øst",
    "fictionalOrgNumberLabel": "Fiktivt organisasjonsnummer",
    "fictionalOrgNumberDescription": "Skriv inn fiktivt organisasjonsnummeret (NO + 14 siffer)"
  },
  "generalInformation": {
    "bankAccountNumber": "Kontonummer",
    "bankAccountNumberDescription": "Eksempel: 1234 56 78903",
    "organizationNumberDescription": "Eksempel: 987 654 321",
    "forestownerAssociation": "Skogeierlag",
    "forestownerAssociationDescription": "Eksempel: SKL nummer eller sted",
    "customerResponsible": "Kundeansvarlig"
  }
}
